import { createContext, useCallback, useContext, useState, ReactNode } from 'react';

interface BudgetPreviewData {
  dailyBudget: number;
  floorPrice: number;
  claimType: string;
}

interface BudgetPreviewContextType {
  preview: BudgetPreviewData;
  setPreview: (data: Partial<BudgetPreviewData>) => void;
}

const defaultPreview: BudgetPreviewData = {
  dailyBudget: 0,
  floorPrice: 50,
  claimType: '',
};

const BudgetPreviewContext = createContext<BudgetPreviewContextType>({
  preview: defaultPreview,
  setPreview: () => {},
});

export function BudgetPreviewProvider({ children }: { children: ReactNode }) {
  const [preview, setPreviewState] = useState<BudgetPreviewData>(defaultPreview);

  const setPreview = useCallback((data: Partial<BudgetPreviewData>) => {
    setPreviewState((prev) => ({ ...prev, ...data }));
  }, []);

  return (
    <BudgetPreviewContext.Provider value={{ preview, setPreview }}>
      {children}
    </BudgetPreviewContext.Provider>
  );
}

export const useBudgetPreview = () => useContext(BudgetPreviewContext);
